<!-- 移动端抽屉 -->
<template>
  <el-drawer
    v-if="isMobile()"
    v-model="detailVisible"
    class="xbb-chatbot-mobile-common-drawer"
    direction="btt"
    header-class="xbb-chatbot-mobile-common-drawer__header"
    :show-close="false"
    size="77%"
    :title="title"
  >
    <template #header="{ close }">
      <div class="drawer__header">
        <el-button style="color: #969799" text @click="close"> 取消 </el-button>
        <h4 class="drawer__header-text">{{ title }}</h4>
        <el-button style="color: #7a52f4" text @click="commit"> 确定 </el-button>
      </div>
    </template>
    <div class="drawer__content">
      <!-- 默认插槽 -->
      <slot></slot>
    </div>
  </el-drawer>
</template>

<script setup>
import { ref, watch } from 'vue'
import { isMobile } from '@/utils'

const emits = defineEmits(['update:showDetail', 'commit'])
const props = defineProps({
  showDetail: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '抽屉示例标题'
  }
})

const detailVisible = ref(props.showDetail)

// 监听props变化，同步到本地状态
watch(
  () => props.showDetail,
  (val) => {
    detailVisible.value = val
  }
)
// 监听本地状态变化，通知父组件
watch(
  () => detailVisible.value,
  (val) => {
    emits('update:showDetail', val)
  }
)

const commit = () => {
  emits('commit')
}
</script>

<style lang="scss" scoped>
:deep(.el-button, .el-button.is-round) {
  padding: 0;
}
.drawer {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-text {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: normal;
      line-height: normal;
      text-align: center;
      letter-spacing: 0em;
      color: #323233;
    }
  }
  &__content {
    padding: 0 12px;

    .footer {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
  }
}
</style>

<style lang="scss">
.xbb-chatbot-mobile-common-drawer {
  border-radius: 20px 20px 0px 0px !important;

  &__header {
    padding: 13px 16px 0;
    margin-bottom: 12px;
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    letter-spacing: 0em;
    color: #323233;
  }
}
.xbb-chatbot-mobile-common-dialog {
  border-radius: 12px;
  box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.1);

  &__header {
    border-bottom: none !important;
  }

  &__body {
    padding: 6px 12px 0 !important;
  }
}
</style>
